import { FormFieldsType } from 'types/formField'
import { getStringWithoutPrefix } from 'utils/utils'
import { AddressFormKeyList } from './constants'
import { AddressFields, AddressFormKey } from './types'

export const getAddressFields = <FieldKeys extends string>(
  formFields: FormFieldsType<FieldKeys>,
  keyPrefix?: string
): AddressFields => {
  return Object.keys(formFields)?.reduce((addressObj, fieldKey) => {
    const addressKey = getStringWithoutPrefix(fieldKey, keyPrefix)
    if (AddressFormKeyList?.includes(addressKey as AddressFormKey)) {
      addressObj[addressKey] = formFields?.[fieldKey]
    }
    return addressObj
  }, {} as AddressFields)
}

export const getAddressFieldVersion = (key: string, convertToV2?: boolean) => {
  const fieldPrefixV1 = 'address'
  const fieldPrefixV2 = 'addressLine'
  if (convertToV2) {
    return key?.startsWith(fieldPrefixV1) ? key?.replace(fieldPrefixV1, fieldPrefixV2) : key
  }
  return key?.startsWith(fieldPrefixV2) ? key?.replace(fieldPrefixV2, fieldPrefixV1) : key
}
